import Vue from 'vue'
import axios from 'axios'
import { Toast, Dialog } from 'vant'
import native from './jsbridge'
import session from './session'

const newError = (code, msg, type = 'axios') => {
  return {
    code,
    msg,
    type
  }
}
var instance = axios.create({
  timeout: 300000,
  headers: {
    'Content-Type': 'application/json',
    "accessToken": "eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiIxMzI5MDQzNjExNSIsImlhdCI6MTczMzk4NjY1NSwiZXhwIjoxNzQxNzYyNjU1fQ.oYS2n9HodJfzMc9sNT8Re9dVoCznhGWesH-BGI7xQJfxoIMpCKszeqM4DlgNmzS4h_cTDSruaNSprqif0Zqymg",
    "Authorization": "Bearer"
  },
})

instance.interceptors.request.use(function (config) {
  const token = session.get('$$token') || ''
  // console.info('客户端传递的token', token)
  //   const token = 'Token_6088d4559e182@205' // 学生
  // const token = 'Token_5fd31f1ecc550@65'
  // const token = 'Token_@12' // 教师
  if (config.method === "post") {
    config.data.token = token
  } else if (config.method === "get") {
    // config.params.token = token
  }
  return config
}, function (error) {
  console.log(error)
  return Promise.reject(error)
})
instance.interceptors.response.use(function (response) {
  const { data, } = response
  if (data.code === 0) {
    return data
  } else if (+data.code === 10001) {
    native.sessionTimeout()
  }
  else {
    Toast(data.msg || '系统繁忙，请稍后重试')
    throw newError(data.code, data.msg)
  }
}, function (error) {
  Toast('系统繁忙，请稍后重试')
  return Promise.reject(error)
})

Vue.prototype.$http = instance

export default instance



// WEBPACK FOOTER //
// ./src/utils/http.js